import type { TeamScopeKey } from '../types/database'

export const SCOPE_LABELS: Record<TeamScopeKey, string> = {
  episodes: 'Episodes & Transcripts',
  dashboard: 'Dashboard Overview',
  guests: 'Guest Intelligence',
  youtube_analytics: 'YouTube Analytics',
  monetization: 'Monetization & AdSense',
  signalcast: 'SignalCast & Trends',
  clips: 'Clips',
  castback: 'Castback',
  voice: 'Voice Intelligence',
  competitive: 'Competitive Intelligence',
  retention: 'Retention Analytics',
  launch: 'Launch Playbook',
  platforms: 'Connected Platforms',
  reality: 'Reality Trends',
}

export function scopeLabel(scope: TeamScopeKey): string {
  return SCOPE_LABELS[scope]
}
